module.exports = __webpack_public_path__ + "static/section-1-064f9639235d0f59ba7b0f78e06f9919.jpg";